<template>
  <div class="app__content">

    <section class="section">
      <div class="section__wrapper">
        <div class="section__content section__copy">
          <h2>Uploader</h2>

          <p>We will apply this <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/">Creative Commons</a> licence to your uploaded videos.</p>
          
          <p>It states that we will use the video you upload only for this project, that we won't use it commercially, and we'll credit you every time it is shown.</p>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="section__wrapper">
        <div class="section__content section__copy">
          <div class="mb-4">

            <upload
              :creditName="creditName"
              :creditLinks="creditLinks"
              :contact="contact"
            />
          </div>
          
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Upload from '../components/Upload';

export default {
  name: 'view-upload',
  data() {
    return {
      creditName: null,
      creditLinks: null,
      contact: null,
    };
  },
  components: {
    Upload,
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// upload.vue?982bb520